// 1026 A1/A9：内测海报版品牌 Logo——「策略咖」+ 橙色咖啡杯 + KBS 两行小字。
// 全站页头/页脚统一使用；light 用于深色底（如首页页脚）。
import "./BrandLogo.css";

export function BrandLogo({ light = false }: { light?: boolean }) {
  return (
    <span className={`aim-logo ${light ? "aim-logo-light" : ""}`}>
      <span className="aim-logo-name">策略咖<svg className="aim-logo-mug" viewBox="0 0 34 38" aria-hidden="true">
        <rect x="2" y="5" width="21" height="25" rx="3" />
        <path d="M23 10.5h3a5.5 5.5 0 0 1 0 11h-3" fill="none" strokeWidth="3.6" />
        <rect x="0" y="32.5" width="26" height="3.6" rx="1.8" />
      </svg></span>
      <span className="aim-logo-divider" aria-hidden="true" />
      <span className="aim-logo-tag"><span>KBS品牌营销</span><span>策略解决方案</span></span>
    </span>
  );
}
